const configs={
    "localhost": {
        API_URL:"https://fur-dev-api.vedasoftinc.click/furservice"
    },
    "fur-dev.vedasoftinc.click": {
        API_URL:"https://fur-dev-api.vedasoftinc.click/furservice"
    },    
    "fur-dev.nmgcloudapps.com":{
        API_URL:"https://dev-d-web-w2.api-nm.cloud/furservice"
    },    
    "fur-dev-int.nmgcloudapps.com": {
        API_URL: "https://dev-int-amber.api-nm.io/furservice"
    },    
    "fur-preprod.neimanmarcus.com": {
        API_URL: "https://prep-d-web-w2.api-nm.cloud/furservice"
    },    
    "fur.neimanmarcus.com": {
        API_URL: "/furservice"
    }
}
module.exports.getApiDomain = () => {
    return configs[window.location.hostname].API_URL
};